export default [
  { path: '/base/warn', name: 'BaseWarn', component: () => import(/* webpackChunkName: "base-warn" */ './index.vue') }
]